import {useEffect, useState} from "react";
import {useStore} from "./useStore";

export const useSubCompanies = ({companyIds = [], searchText = ""}) => {
    const {companyStore} = useStore();

    const [loadedCompanyIds, setLoadedCompanyIds] = useState([]);
    const [subCompanies, setSubCompanies] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchSubCompanies = async ({company, companies = [], searchText = ""}) => {
        return await companyStore.getSubCompanyList({
            companyId: company,
            companies: companies?.join(".") || "",
            activity: "enabled",
            searchText: searchText.toLocaleLowerCase("tr-TR"),
            limit: 1000
        });
    };

    const loadSubCompanies = async ({companyIds = [], searchText = ""}) => {
        setLoading(true);
        try {
            if (!companyIds) return;
            if (searchText.trim() == "") return;

            const newCompanyIds = companyIds.filter(
                companyId => !loadedCompanyIds.includes(companyId)
            );
            if (newCompanyIds.length === 0) return;

            const subCompanyResponse = await fetchSubCompanies({
                companies: newCompanyIds,
                searchText
            });
            const newSubCompanies = subCompanyResponse.rows.filter(
                subCompany => !subCompanies.find(({_id}) => _id === subCompany._id)
            );
            setSubCompanies(prev => [...prev, ...newSubCompanies]);
            setLoadedCompanyIds([...loadedCompanyIds, ...newCompanyIds]);
        } catch (e) {
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadSubCompanies({companyIds, searchText});
    }, []);

    return {subCompanies, subCompanyLoading: loading, loadSubCompanies};
};
